import { PortfolioThemeControl } from '../components/PortfolioThemeControl';
import { ReportIssue } from './ReportIssue';
import { OfflineStatus } from './OfflineStatus';
import { ConfirmationDialog } from './ConfirmationDialog';
import { Link,NavLink,useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { listAvailablePacks,type PackContract } from '../domain/packs/registry';
import { providerRoutes,routeFraming,type ProviderRoute } from '../domain/packs/cleaning';
const providerRouteLabel:Record<ProviderRoute,string>={certified_agency:'인증받은 가사서비스 제공기관',brokerage_platform:'중개·매칭 플랫폼',unknown:'아직 모르겠어요'};
export function Mark(){return <svg className="mark" viewBox="0 0 48 48" aria-hidden="true"><path d="M8 15h13M27 33h13M15 25l6 6 13-16"/></svg>}
export function Layout({children,quietNav=false}:{children:React.ReactNode;quietNav?:boolean}){const {pathname}=useLocation();useEffect(()=>{window.scrollTo({top:0,behavior:'instant'});},[pathname]);return <><a className="skip" href="#main">본문으로 건너뛰기</a><header><Link className="brand" to="/"><Mark/><span>적힌대로</span></Link><nav className={quietNav?'quiet-nav':undefined} aria-label="주요 메뉴"><NavLink to="/projects">내 계약</NavLink><NavLink to="/guide/moving-estimate-checklist">확인 기준</NavLink><NavLink to="/support">도움말</NavLink></nav></header><OfflineStatus/><ConfirmationDialog/><main id="main">{children}</main><footer><PortfolioThemeControl/><ReportIssue/><Link to="/privacy">개인정보 처리방침</Link><Link to="/terms">이용약관</Link><Link to="/support">문의</Link>{listAvailablePacks().map((pack)=><a key={pack.packId} href={pack.anchor.url}>{pack.name} 기준 원문</a>)}<small>기준 확인 {listAvailablePacks().map((p)=>p.anchor.checkedAt).sort().at(-1)}</small></footer></>}

/** 팩의 공적 기준선 고지. 강행/권장과 적용 대상을 숨기지 않는다. */
export function AnchorNote({pack,route}:{pack:PackContract;route:ProviderRoute|null}){
  const framing=pack.providerBranch?routeFraming[route??'unknown']:null;
  return <aside className="anchor-note" role="note">
    <div className="anchor-head"><b>{framing?framing.badge:pack.anchor.force==='mandatory'?'법정 기재사항':'참고 기준선'}</b><a href={pack.anchor.url} target="_blank" rel="noreferrer">{pack.anchor.doc} {pack.anchor.article}</a></div>
    <p>{framing?framing.note:`${pack.anchor.doc} ${pack.anchor.article}의 기재 항목을 기준으로 확인해요.`}</p>
    <small>적용 대상: {pack.anchor.appliesTo} · 확인 {pack.anchor.checkedAt}</small>
    <small className="anchor-limit">적힌대로는 적정가·품질·위법·책임을 판정하지 않아요. 적힌 것과 안 적힌 것만 가려요.</small>
  </aside>;
}

/** 계약 상대 경로 선택. 청소 팩의 첫 동작이며 이후 문구의 성격을 정한다. */
export function ProviderRoutePicker({value,onChange}:{value:ProviderRoute|null;onChange:(route:ProviderRoute)=>void}){
  return <fieldset className="route-picker"><legend>이 계약을 누구와 맺나요?</legend>
    <p className="route-why">가사근로자법은 <b>인증받은 제공기관</b>과의 계약에만 적용돼요. 중개 플랫폼으로 개인과 맺는 계약에는 적용되지 않을 수 있어서, 같은 항목이라도 성격이 달라져요.</p>
    {providerRoutes.map((route)=><label className={`route-option ${value===route?'selected':''}`} key={route}>
      <input type="radio" name="providerRoute" value={route} checked={value===route} onChange={()=>onChange(route)}/>
      <span><b>{providerRouteLabel[route]}</b><small>{routeFraming[route].badge}</small></span>
    </label>)}
  </fieldset>;
}

export function FilePicker({label,hint,accept,inputLabel,buttonLabel='파일 고르기',fileName,onFile}:{label:string;hint:string;accept:string;inputLabel:string;buttonLabel?:string;fileName?:string;onFile:(file:File|null)=>void}){
  return <label className="file-picker">
    <span>{label}</span>
    <input className="visually-hidden" type="file" accept={accept} aria-label={inputLabel} onChange={(event)=>{onFile(event.target.files?.[0]??null);event.currentTarget.value=''}}/>
    <span className="file-picker-button">{buttonLabel}</span>
    <small>{fileName?`선택한 파일: ${fileName}`:hint}</small>
  </label>;
}

/** 별도 유료 실물이 생기기 전까지 핵심 도구와 데이터 이동권은 항상 무료다. */
export function FreeRightsNote(){
  return <aside className="pay-pack open-now" aria-label="지금 열려 있는 기능">
    <p className="eyebrow">지금 전부 무료</p>
    <h2>확인에 필요한 건 다 열려 있어요.</h2>
    <ul className="open-list">
      <li>안 적힘 항목과 이유 보기</li>
      <li>업체에 보낼 요청 문장 복사</li>
      <li>요청서·전체 기록 PDF 보관</li>
      <li>견적 최대 9개 같은 축 비교</li>
      <li>취소·연기와 정산·영수증 기록</li>
      <li>전체 기록 백업·복원</li>
    </ul>
    <p className="pay-links">기록은 이 기기에만 있고 언제든 <Link to="/settings/data">내 데이터</Link>에서 가져가거나 지울 수 있어요.</p>
  </aside>;
}

